import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import type { PreferenceHistoryResponse } from '../@types/preferences';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

interface UsePreferenceHistoryParams {
  preferenceKey: string;
}

export const usePreferenceHistory = ({
  preferenceKey,
}: UsePreferenceHistoryParams) => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  const path = `/${endpoints.preferencesHistory}/${preferenceKey}`;

  return useQuery<
    PreferenceHistoryResponse,
    AxiosError<unknown>,
    PreferenceHistoryResponse,
    [string, string, string, string]
  >(
    [
      endpoints.preferencesHistory,
      preferenceKey,
      currentOrganizationId,
      currentPracticeId,
    ],
    async () => {
      const response =
        await makeAPIRequestReactQuery<PreferenceHistoryResponse>(
          path,
          {
            practiceId: currentPracticeId,
          },
          'GET',
          {
            headers: {
              org: currentOrganizationId,
              practice: currentPracticeId,
            },
          },
        );
      return response;
    },
    {
      enabled:
        !!preferenceKey && !!currentOrganizationId && !!currentPracticeId,
    },
  );
};
